import React from "react";
import { Link } from "react-router-dom";
import { Phone, CalendarDays } from "lucide-react";
import Reveal from "./Reveal";
import { CONTACT, aCity } from "../../mock";

export const ADVISOR_CITIES = ["Dol-de-Bretagne", "Mont-Dol", "Combourg", "Pontorson"];

export function LocalAdvisor({ city }) {
  if (!ADVISOR_CITIES.includes(city)) return null;
  return (
    <section className="max-w-7xl mx-auto px-5 lg:px-8 pt-16" data-testid="city-advisor">
      <Reveal>
        <div className="rounded-[32px] bg-[#f3ede1] ring-1 ring-[#e6dcc8] p-7 sm:p-10 flex flex-col md:flex-row md:items-center gap-8">
          <div role="img" aria-label={`François Cornuey, responsable commercial Ouest Conciergerie à ${city}`} data-testid="city-advisor-photo"
            className="w-36 h-36 lg:w-44 lg:h-44 rounded-full ring-4 ring-[#faf7f0] shadow-[0_20px_40px_-20px_rgba(19,38,28,0.5)] shrink-0 bg-[#3b3b3a] bg-no-repeat"
            style={{ backgroundImage: "url(/photos/commercial-francois.jpg)", backgroundSize: "92% auto", backgroundPosition: "50% 70%" }} />
          <div className="flex-1">
            <span className="text-sm font-bold uppercase tracking-[0.2em] text-[#c4703f]">Votre interlocuteur à {city}</span>
            <p className="mt-3 font-logo font-black text-2xl lg:text-3xl text-[#13261c] leading-tight" data-testid="city-advisor-name">François, responsable commercial<span className="text-[#d9895a]">.</span></p>
            <p className="mt-3 text-[#5a6158] leading-relaxed max-w-2xl">C'est François qui vous reçoit et suit votre projet {aCity(city)} : premier rendez-vous, visite de votre logement et mise en route de la location.</p>
          </div>
          <div className="flex flex-col gap-3 shrink-0">
            <Link to="/rendez-vous" data-testid="city-advisor-rdv" className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 font-bold bg-[#13261c] hover:bg-[#2a4636] text-white transition-colors">
              <CalendarDays className="w-5 h-5" /> Rencontrer François
            </Link>
            <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} data-testid="city-advisor-phone" className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 font-bold ring-1 ring-[#13261c]/20 text-[#13261c] hover:bg-white transition-colors">
              <Phone className="w-5 h-5" /> {CONTACT.phone}
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
